import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
/**
 * View report
 */
@Component({
  selector: 'app-view-report',
  templateUrl: './view-report.component.html',
  styleUrls: ['./view-report.component.scss'],
})
export class ViewReportComponent implements OnInit {
  /**
   * report url
   */
  @Input() public reportUrl: string;

  safeUrl;

  /**
   * constructor to inject dependency
   * @param sanitizer domsanitizer
   */
  constructor(private sanitizer: DomSanitizer) {}

  /**
   * initialize component
   */
  ngOnInit(): void {
    this.safeHtml(this.reportUrl);
  }

  /**
   * sanitize
   * @param html html string
   */
  safeHtml(html) {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(html);
  }
}
